// ============================================================
//  PROTECTED ROUTE — nur für eingeloggte Redaktion (admin/editor)
// ============================================================
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ children, nurAdmin = false }) {
  const { user, role, loading } = useAuth();

  if (loading) {
    return <div className="mx-auto max-w-md px-4 py-32 text-center text-dark/60">Lädt …</div>;
  }
  if (!user || !role) {
    return <Navigate to="/admin/login" replace />;
  }
  if (nurAdmin && role !== "admin") {
    return (
      <div className="mx-auto max-w-md px-4 py-32 text-center text-dark/60">
        Diese Seite ist nur für Admins.
      </div>
    );
  }
  return children;
}
